import type { FaireProductEntity } from "../../entity_types/product";

export const p_rcygvv5awr: FaireProductEntity = {
  token: "p_rcygvv5awr",
  type: "product",
  name: "The Crandle - Cranberry Sauce Candle",
  brandToken: "b_d72c56fe",
  brandName: "54 Celsius",
  imageUrl:
    "https://cdn.faire.com/fastly/a86ff6a08c46fa29ebce341aa5ca625fcd76c9bb608f24ca54487887bd7b6ec4.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/370deaad0c2a0c46206bd88e63fbc6d76d24533036d74e49b7b822360f96e8bf.webp",
    "https://cdn.faire.com/fastly/9dcb47f2b3e497eea6d1529f57de91903ef9fd3a2fb68290cb3e2e68bdb9d083.webp",
    "https://cdn.faire.com/fastly/29da1efd75ea7dda88beb9aa7d1b4fef85dfddc4a81608c072d9620b8c6fcf36.webp",
    "https://cdn.faire.com/fastly/881ad58f7e31d0c726eaa2bf3312596180227f6e4d4e77b7f8b4b34da4f4cea6.png",
    "https://cdn.faire.com/fastly/14a2f06c4b47bc2601bee5c0c89aa14aa1884f82137445b19634e880010858be.png",
    "https://cdn.faire.com/fastly/46525fad63b713dc3a8b660c74f331ab6cde8ca61dc15092e776aec986cac6a0.jpeg",
  ],
  priceDollars: 17.5,
  description:
    'Light up your holidays with pure nostalgia!\n\nThis isn’t just a candle, it’s The Crandle™.\n\nThe only holiday candle that looks and smells like Jellied Cranberry Sauce plopped straight out of the can.\n\nLit or unlit, it’s the perfect addition to any holiday table—right next to the ole gravy boat.\n\nThe Crandle™ will have your nostrils saying, “Yum,” and your tipsy Uncle doing a double take.\nJust make sure he doesn’t try to eat it!\n\nCreated by Seth and Vikas:\nFor every Crandle™ sold, we donate a can of food to someone in need.\n\nProduct Details:\n\nDimensions: 4" H x 3" Diam\nBurn Time: Approx. 40 hours\nMaterial: Paraffin wax',
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:14.890Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
